import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/chapterSetup/main"));

const ChapterSetup = () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default ChapterSetup;
